<template>
    <page>
      <div :load="doInit">
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Date Range
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ePanelHeaderColor">
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs6>
                    <cal-picker v-model="reportForm.expDateFrom" :label="labels.expDateFrom" v-validate="fromDateValidation(reportForm.expDateTo)" :data-vv-as="labels.expDateFrom" data-vv-name="expDateFrom" :error-messages="errors.collect('expDateFrom')"></cal-picker>
                  </v-flex>
                  <v-flex xs6>
                    <cal-picker v-model="reportForm.expDateTo" :label="labels.expDateTo" v-validate="toDateValidation(reportForm.expDateFrom)" :data-vv-as="labels.expDateTo" data-vv-name="expDateTo" :error-messages="errors.collect('expDateTo')"></cal-picker>
                  </v-flex>
                  <v-flex xs6>
                    <cal-picker v-model="reportForm.renTranDate" :label="labels.renTranDate" v-validate="'required'" @change="getTranDateRange" :data-vv-as="labels.renTranDate" data-vv-name="renTranDate" :error-messages="errors.collect('renTranDate')"></cal-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
                          </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ePanelHeaderColor">
        <v-card>
          <v-card-text>
            <v-form>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <!-- Billing Account No. From -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.billAcct" :label="labels.billAcct" :error-messages="errors.collect('billAcct')"
                    :data-vv-as="labels.billAcct" data-vv-name="billAcct" append-icon="mdi-magnify" @click:append="getHelpList('billAcct')" readonly
                    v-validate="'required'"></v-text-field>
                  </v-flex>
                  <!-- Financial Institution -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.finInst" :label="labels.finInst" :error-messages="errors.collect('finInst')"
                    :data-vv-as="labels.finInst" data-vv-name="finInst" append-icon="mdi-magnify" @click:append="getHelpList('finInst')" readonly
                    v-validate="'required'"></v-text-field>
                  </v-flex>
                  <!-- Policy Type -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')"
                    :data-vv-as="labels.polType" data-vv-name="polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly
                    v-validate="'required'"></v-text-field>
                  </v-flex>
                  <!-- Scheme -->
                  <v-flex xs12 sm12 md12 lg12>
                    <v-text-field readonly v-model="reportForm.scheme" :label="labels.scheme" :error-messages="errors.collect('scheme')"
                    :data-vv-as="labels.scheme" data-vv-name="scheme" append-icon="mdi-magnify" @click:append="multiSchemeList = true"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
                                  </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <v-spacer class="mt-2"></v-spacer>
        <v-form>
          <v-layout row wrap>
          <v-flex xs3>
              <v-checkbox
                      :label="labels.pbPrtParam"
                      v-model="reportForm.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="labels.pbPrtParam"
                    />
                  </v-flex>
                  <v-flex xs3>
          <v-checkbox
                            :label="labels.sendToPrinter"
                            v-model="reportForm.sendToPrinter"
                            :error-messages="errors.collect('sendToPrinter')"
                            data-vv-name="sendToPrinter"
                            :data-vv-as="labels.sendToPrinter"
                            :disabled="query"
                          ></v-checkbox>
        </v-flex>
        </v-layout>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg6 xs12>
              <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doSubmit">
                <v-icon left dark>mdi-file-export</v-icon>
                {{labels.export}}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="reportForm.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{format.label}}</span>
                  <v-icon :color="format.color">{{format.icon}}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
        <v-dialog v-model="multiPolTypeList" width="900px" persistent>
          <multi-pol-type-help-list :pt="reportForm.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
        </v-dialog>
        <v-dialog v-model="multiSchemeList" width="900px" persistent>
          <multi-scheme-help-list :scheme="reportForm.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
        </v-dialog>
        <v-dialog v-model="multiInterList1" width="900px" persistent>
          <multi-intermediary-help-list
            :intr="reportForm.finInst"
            intrGrp="AG"
            helpListTitle="Billing Accounts HelpList"
            @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
        </v-dialog>
        <v-dialog v-model="multiInterList2" width="900px" persistent>
          <multi-intermediary-help-list
            :intr="reportForm.finInst"
            intrGrp="12"
            helpListTitle="Financial Institutions HelpList"
            @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
        </v-dialog>

        <v-dialog v-model="promptExeJob" width="500px" persistent>
          <batch-job-scheduler
            v-if="promptExeJob"
            :skipValidate="batchForm.skipValidate"
            :jobKeys="reportForm"
            :showJobMode="false"
            @close="promptExeJob = false"
            @doPopulate="processBatch($event)"
          />
        </v-dialog>

      <warning v-model="promptResubmit" @ok="doAccept">
        <div>{{ warningMsg1 }}</div>
        <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
        <div>{{ warningMsg2 }}</div>
      </warning>
    </page>
  </template>
<script>
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { expandURI } from '@/utils/ajax'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        expDateFrom: 'Expiry Date From*',
        expDateTo: 'Expiry Date To*',
        renTranDate: 'Renewal Transaction Date',
        billAcct: 'Billing Account(s)',
        finInst: 'Financial Institutions',
        polType: 'Policy Type',
        pbPrtParam: 'Print Runtime Parameters',
        scheme: 'Scheme',
        format: 'Export Format',
        export: 'Export to',
        sendToPrinter: 'Send output to printer'
      },
      reportForm: {
        expDateFrom: undefined,
        expDateTo: undefined,
        renTranDate: new Date(),
        billAcct: 'All',
        finInst: 'All',
        polType: 'All',
        pbPrtParam: true,
        scheme: 'All',
        format: undefined,
        sendToPrinter: true
      },
      // HelpList
      multiPolTypeList: false,
      multiSchemeList: false,
      multiInterList1: false,
      multiInterList2: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      billAcctNoList: [],
      isPermitted100: true,
      isPermitted200: true,
      intrGrp: undefined,
      panel: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initAutoBatchRenewalUpp
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
      this.getTranDateRange()
    },
    async getTranDateRange() {
      const apiURI = this.menu.getTranDateRange
      if (apiURI &&
        this.reportForm.renTranDate !== null &&
        this.reportForm.renTranDate !== '' &&
        this.reportForm.renTranDate !== undefined) {
        this.loading = true
        const expand = {
          tranDate: removeTime(this.reportForm.renTranDate)
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          if (data.isPermitted100) {
            this.isPermitted100 = true
          } else {
            this.isPermitted100 = false
          }
          if (data.isPermitted200) {
            this.isPermitted200 = true
          } else {
            this.isPermitted200 = false
          }
        }
        this.loading = false
      }
    },
    getHelpList(field) {
      switch (field) {
        case 'billAcct':
          this.intrGrp = 'AG'
          this.multiInterList1 = true
          break
        case 'finInst':
          this.intrGrp = '12'
          this.multiInterList2 = true
          break
      }
    },
    defaultSendToPrinter() {
      if (this.miscparams) {
        this.reportForm.sendToPrinter = this.miscparams.sendToPrinter
      }
    },
    doAssignPolType(Obj) {
      this.reportForm.polType = []
      this.reportForm.polType = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.reportForm.scheme = []
      this.reportForm.scheme = Obj.finalSelectedItems.toString()
    },
    async doAssignInter(Obj) {
      switch (this.intrGrp) {
        case 'AG':
          this.reportForm.billAcct = []
          this.reportForm.billAcct = Obj.finalSelectedItems.toString()
          break
        case '12':
          this.reportForm.finInst = []
          this.reportForm.finInst = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.multiPolTypeList = false
      this.multiSchemeList = false
      this.multiInterList1 = false
      this.multiInterList2 = false
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.checkIsPremitted()
        }
      })
    },
    checkIsPremitted() {
      if (this.isPermitted100 && this.isPermitted200) {
        if (this.isBatchManager === true) {
          this.promptExeJob = true
        } else {
          this.getAutoBatchRenewalUpp()
        }
      } else {
        if (!this.isPermitted100 && this.isPermitted200) {
          this.$toast.error(this.labels.renTranDate + ': Not permitted for Transaction Date Range Type 100')
        } else if (this.isPermitted100 && !this.isPermitted200) {
          this.$toast.error(this.labels.renTranDate + ': Not permitted for Transaction Date Range Type 200')
        } else if (!this.isPermitted100 && !this.isPermitted200) {
          this.$toast.error(this.labels.renTranDate + ': Not permitted for Transaction Date Range Type 100 & 200')
        }
      }
    },
    async getAutoBatchRenewalUpp() {
      this.resetMessages()
      const apiURI = this.menu.getAutoBatchRenewalUpp
      this.loading = true
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, this.reportForm))
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async processBatch(bmForms) {
      this.resetMessages()
      const apiURI = this.menu.exeAutoBatchRenewalUpp
      this.loading = true
      if (apiURI) {
        try {
          let massageForm = clone(bmForms)
          if (massageForm.renTranDate) {
            massageForm.renTranDate = removeTime(massageForm.renTranDate)
          }
          const result = await this.$http.post(apiURI, massageForm)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async processExportErrRecList(lists) {
      const apiURI = this.menu.genAutoBatchRenewalErrRec
      if (apiURI) {
        try {
          this.loading = true
          let form = clone(this.reportForm)
          form.errRecList = lists.errRecList
          await this.$http.post(apiURI, form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processExportRptWrkFileList(lists) {
      const apiURI = this.menu.genAutoBatchRenewalPol
      if (apiURI) {
        try {
          this.loading = true
          let form = clone(this.reportForm)
          form.rptWrkFileList = lists.rptWrkFileList
          form.tRiOutSummaryList = lists.tRiOutSummaryList
          await this.$http.post(apiURI, form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processExporttSummaryList(lists) {
      const apiURI = this.menu.genAutoBatchRenewalSum
      if (apiURI) {
        try {
          this.loading = true
          let form = clone(this.reportForm)
          form.tSummaryList = lists.tSummaryList
          await this.$http.post(apiURI, form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processExportPremGstTaxInv(lists) {
      for (let i in lists.premGstTaxInv) {
        const apiURI = this.menu.genPremGstTaxInv
        if (apiURI) {
          try {
            this.loading = true
            await Promise.all([this.$http.post(apiURI, lists.premGstTaxInv.get(i))])
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async processExportRenCvrLet(lists) {
      for (let i in lists.renCvrLet) {
        const apiURI = this.menu.genRenCvrLet
        if (apiURI) {
          try {
            this.loading = true
            var obj = lists.renCvrLet.get(i)
            const form = {
              polNo: obj.polNo,
              renCnt: obj.renCnt,
              endtCnt: obj.endtCnt
            }
            await Promise.all([this.$http.post(apiURI, form)])
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async processExportSr5151List(lists) {
      for (let i in lists.sr5151List) {
        const apiURI = this.menu.export
        if (apiURI) {
          try {
            this.loading = true
            var obj = lists.sr5151List.get(i)
            const form = {
              polNo: obj.polNo,
              renCnt: obj.renCnt,
              endtCnt: obj.endtCnt,
              copy: 1,
              printSection: 0,
              format: 'PDF'
            }
            await Promise.all([this.$http.post(apiURI, form)])
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'entry|valDateFrom:' + toDate1
      } else {
        return 'required'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'entry|valDateTo:' + fromDate1 + '|valDiffDateTo:' + fromDate1
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var fromDate = args[0]
        if (fromDate) {
          return !(isAfter(removeTime(value), removeTime(fromDate)))
        }
      }
    })
    this.$validator.extend('valDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var toDate = args[0]
        if (toDate) {
          return !(isAfter(removeTime(toDate), removeTime(value)))
        }
      }
    })
    this.$validator.extend('valDiffDateTo', {
      getMessage(field, args) {
        return 'Cannot be more than 7 days'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var toDate = args[0]
        var fDate = new Date(value)
        var tDate = new Date(toDate)
        var diffYear = fDate.getFullYear() - tDate.getFullYear()
        var diffMonth = (fDate.getMonth() + 1) - (tDate.getMonth() + 1)
        var diffDate = fDate.getDate() - tDate.getDate()
        if (toDate) {
          return diffDate <= 7 && diffMonth === 0 && diffYear === 0
        }
      }
    })
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin,
    batchManagerMixin
  ],
  components: {
    MultiPolTypeHelpList,
    MultiSchemeHelpList,
    MultiIntermediaryHelpList,
    BatchJobScheduler
  }
}
</script>
